/**
 * 动态加载js
 * @param url
 * @param callback
 * @returns {Promise<any>}
 */
export function loadingJs(url, callback) {
    return new Promise((resolve, reject) => {
        let fn = callback || function () {};
        let script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        document.head.appendChild(script);
        if (script.addEventListener) {
            script.addEventListener('load', function () {
                console.log("加载完成",url);
                fn();
                resolve();
            }, false);
        } else if (script.attachEvent) {
            script.attachEvent('onreadystatechange', function () {
                let target = window.event.srcElement;
                if (target.readyState == 'loaded') {
                    console.log("加载完成",url);
                    fn();
                    resolve();
                }
            });
        }
    })
}



// WEBPACK FOOTER //
// ./src/assets/js/load_js.js